var s = window.s || {};

s.dom = s.dom || {};
s.paths = {
	expressInstall: 'swf/expressInstall.swf',
	jPlayer: 'swf/jquery.jplayer-2.9.2.swf',
};
s.cssSelectors = {
	header: "header",
	footer: "#footer",
	main: "#main"
};
s.scriptPaths = {
	vk: "//vk.com/js/api/openapi.js?116",
	ok: "//connect.ok.ru/connect.js",
	fb: true,
	tw: "//platform.twitter.com/widgets.js",
};
s.initSelectControls = function(context){
	var $list = context.find("select.select:not(.skip)");
	if ($list.length) {
		$list.addClass("skip");
		$list.selecter();
		
		$list.each(function(){
			var $this = $(this);
			if ($this.data("before")) {
				$this.siblings(".selecter-selected")
					.attr("data-before", $this.data("before"));
			}
		});
	}
};
s.initFlexImage = function(context){
	context.find(".flex-image:not(.skip)").each(function(){
		var $this = $(this);
		$this.closest(".flex-image-holder").css({
			background: "url("+$this.attr("src")+") no-repeat 50% 50%",
			backgroundSize: "cover"
		})
		$this.addClass("skip");
	});
};

s.initFooterAtBottom = function(){
	s.dom.$footer.css({
		'margin-top': -s.dom.$footer.outerHeight()
	});
	s.dom.$main.css({
		'padding-bottom': s.dom.$footer.outerHeight()
	})
}

s.scrollToElement = function($target, timeout){
	if (timeout !== undefined) {
		window.setTimeout(function(){
			s.scrollToElement($target);
		}, timeout);
		return;
	}

	try {
		if (typeof $target === 'string') {
			$target = s.dom.$body.find($target);
		}
		if ($target.length) {
			$("html,body").stop().animate({scrollTop: $target.offset().top - 50}, 600, 'swing');
		}
	} catch (e) {;}
};

s.initViewport = function () {
	if (device.mobile()) {

		if (window.innerWidth < 480) {
			var _scale = window.innerWidth / 480;
			s.dom.$head.append('<meta name="viewport" content="initial-scale='+_scale+', maximum-scale='+_scale+', target-densitydpi=device-dpi, width=480, user-scalable=no" />');
		} else {
			s.dom.$head.append('<meta name="viewport" content="initial-scale=1, maximum-scale=1, target-densitydpi=device-dpi, width=device-width, user-scalable=no" />');
		}

		var scroll_h = s.dom.$window.innerHeight() - s.dom.$html.find('.player-panel').height() - 50;
		s.dom.$html.find('.scroll-item').height(scroll_h);
	}
};

s.initEventMapMove = function () {
	var mapDesktop = s.dom.$main.find('#desktop-map');
	var mapMobile = s.dom.$main.find('#mobile-map');
	var mapContainer = s.dom.$main.find('#map-container');

	move();

	s.dom.$window.resize(function () {
		move();
	});

	function move() {
		if (window.innerWidth <= 1200 && $.trim(mapMobile.html()) == '') {
			mapMobile.append(mapContainer);
		} else if (window.innerWidth > 1200 && $.trim(mapDesktop.html()) == '') {
			mapDesktop.append(mapContainer);
		}
	}
};

s.hideSearchForm = function () {
	var item = s.dom.$header.find(".search-item");
	var form = item.find(".search-form");

	if (item.hasClass('opened')) {
		form.css({'width': 0});
		item.removeClass('opened');
	}
};

s.tabletFix = null;
s.mobileFix = null;
$(function(){
	s.proxy();
	s.setupPaths();
	s.cacheElements();
	
	s.tabletFix = $('<div class="tablet-fix"></div>').appendTo(s.dom.$body);
	s.mobileFix = $('<div class="mobile-fix"></div>').appendTo(s.dom.$body);
	
	s.menu.init();
	s.initFooterAtBottom();
	s.share.init(".js-share a");

	s.initEventMapMove();

	s.wrapIframes('.release .description');
	
	s.dom.$window.resize(function(){
		s.initFooterAtBottom();
	});
	s.dom.$window.on("ajax.loaded", function(){
		s.popup.closeAll();
		s.initSelectControls(s.dom.$main);
		s.initFlexImage(s.dom.$main);
		s.wrapIframes('.release .description');
	});
	
	var windowScroll = s.dom.$window.scrollTop();
	s.dom.$window.scroll(function(){
		var winScroll = s.dom.$window.scrollTop();
		
		if (winScroll > 170 && (winScroll - windowScroll) <= 0) {
			if ( ! s.dom.$header.hasClass("fixed-show") || s.dom.$header.hasClass("fixed-hide")) {
				s.dom.$header.addClass("fixed-show");
				s.dom.$header.removeClass("fixed-hide");
			}
		} else if (s.dom.$header.hasClass("fixed-show") || ! s.dom.$header.hasClass("fixed-hide")) {
			s.dom.$header.addClass("fixed-hide");
			s.dom.$header.removeClass("fixed-show");
		}

		windowScroll = s.dom.$window.scrollTop();

		if (windowScroll > 160){
			if ( ! s.dom.$header.hasClass("fixed")) {
				s.dom.$header.addClass("fixed");
			}
		} else if (s.dom.$header.hasClass("fixed")) {
			s.dom.$header.removeClass("fixed");
		}
		if (windowScroll > 150){
			if ( ! s.dom.$header.hasClass("fixed-hide")) {
				s.dom.$header.addClass("fixed-hide");
			}
			s.hideSearchForm();
		} else if (s.dom.$header.hasClass("fixed-hide")) {
			s.dom.$header.removeClass("fixed-hide");
		}
	});

	s.dom.$window.load(function () {
		s.dom.$head.find('[name="viewport"]').remove();
		s.initViewport(window.innerWidth);
	});

	if (device.mobile() || device.tablet()) {
		s.dom.$window.on("orientationchange", function () {
			s.dom.$head.find('[name="viewport"]').remove();
			setTimeout(function () {
				s.initViewport();
			}, 200);
		});
	}

	s.counters.init();
	
	s.initList.push("initFlexImage", "initSelectControls");
	
	s.executeInitList(s.dom.$body);
});


